<artemis-tasks-card [pendingTasks]="pendingTasks" [overdueTasks]="overdueTasks" [tasksStats]="stats"></artemis-tasks-card>
<div class="right-side">
  <div class="customer-button">
    <button class="btn btn_blue-gradient-rounded" mat-button ubi-round-button [artemisDropdownToggler]="customersCreationsList">
      + {{ 'customer.button' | translate }}
    </button>
    <artemis-dropdown-menu class="dropdown_after-line" #customersCreationsList>
      <a class="right-panel__dropdown-items" dropdown-item routerLink="/customers/onboarding" title="Manual customer input">
        {{ 'customer.title.manual_input' | translate }}
      </a>
      <a class="right-panel__dropdown-items" dropdown-item routerLink="/customers/batch-upload" title="Upload file with customers">
        {{ 'customer.title.batch_upload' | translate }}
      </a>
      <a class="right-panel__dropdown-items" dropdown-item routerLink="/handshakes" title="Purchase Bizfile From Handshakes" [ngClass]="{'dropdown-item_disabled': !enableHandshakes}">
        {{ 'customer.title.purchase_bizfile_from_handshakes' | translate }}
      </a>
      <a class="right-panel__dropdown-items" dropdown-item routerLink="/opencorporates" title="Import From OpenCorporates" [ngClass]="{'dropdown-item_disabled': !enableOpenCorporates}">
        {{ 'customer.title.import_from_opencorporates' | translate }}
      </a>
    </artemis-dropdown-menu>
  </div>
  <artemis-quick-scan-card></artemis-quick-scan-card>
  <artemis-version-card></artemis-version-card>
</div>
